import { Injectable } from '@angular/core';
import { Page } from '../../components/ui/filterable-table/tableViewAbstractComponent';
import { GatewayAPIService } from '../../core/gateway-api.service';
import { StorageService } from '../../core/storage/storageService';
import { TerminalTransactionRequest } from '../orders/terminalTransactionRequest';
import { TerminalTransaction } from './transaction';
import { TransactionFacade } from './transactionFacade';
import { TransactionResponse } from './transactionResponse';
import { OrderDetails } from '../orders/orderDetails';
import { TransactionSummary } from './transactionSummary';
import { Merchant } from '../merchant/merchant';

@Injectable({
  providedIn: 'root',
})
export class TransactionService {
  //options = { authenticate: true, setRoot: true, updateAuthHeader: false };
  options = { authenticate: true, setRoot: true };

  constructor(
    private api: GatewayAPIService,
    private storage: StorageService,
  ) {}

  sendTransactionToCustomer(
    email: string,
    order: OrderDetails,
    transactionType: string,
  ): Promise<boolean> {
    const body = {
      email: email,
      order: order,
      transactionType: transactionType,
    };

    return this.api.apiCallSane(
      '/transaction/send-to-customer',
      'POST',
      this.api.getDefaultHeaders(),
      null,
      body,
      this.options,
    );
  }

  // sendSale(order: TerminalTransactionRequest, merchantId:string, includesInvoice:boolean): Promise<TransactionResponse> {

  //     // let data = {
  //     //     order: order,
  //     //     merchantId: merchantId,
  //     //     newInvoice: includesInvoice,
  //     // }

  //     return this.api.apiCallGateway(
  //         //"/terminal/sale",
  //         "/vt/process",
  //         'POST',
  //         this.api.getDefaultHeaders(),
  //         null,
  //         order,
  //         this.options
  //     );
  // }

  // sendVoid(originalTransactionId:string, merchantId:string): Promise<TransactionResponse> {

  //     let data = {
  //         transactionId: originalTransactionId,
  //         merchantId: merchantId
  //     }

  //     return this.api.apiCallSane(
  //         "/terminal/void",
  //         'POST',
  //         this.api.getDefaultHeaders(),
  //         null,
  //         data,
  //         this.options
  //     );
  // }

  sendGatewayTransaction(order: TerminalTransactionRequest): Promise<TransactionResponse> {
    return this.api.apiCallSane(
      '/vt/process',
      'POST',
      this.api.getDefaultHeaders(),
      null,
      order,
      this.options,
    );
  }

  sendGatewayTransactionPayableInvoice(order: TerminalTransactionRequest): Promise<TransactionResponse> {
    return this.api.apiCallGateway(
      '/vt/process',
      'POST',
      this.api.getDefaultHeaders(),
      null,
      order,
      this.options,
    );
  }

  sendACHTransaction(
    order: TerminalTransactionRequest,
  ): Promise<TransactionResponse> {
    return this.api.apiCallGateway(
      '/ach/process',
      'POST',
      this.api.getDefaultHeaders(),
      null,
      order,
      this.options,
    );
  }

  // sendRefund(originalTransactionId:string, merchantId:string, amountToRefund:number): Promise<TransactionResponse> {

  //     let data = {
  //         transactionId: originalTransactionId,
  //         merchantId: merchantId,
  //         amount: amountToRefund
  //     }

  //     return this.api.apiCallSane(
  //         "/terminal/refund",
  //         'POST',
  //         this.api.getDefaultHeaders(),
  //         null,
  //         data,
  //         this.options
  //     );

  // }

  // sendVerify(transaction: TerminalTransaction): Promise<TransactionResponse> {

  //     return this.api.apiCallSane(
  //         "/terminal/verify",
  //         'POST',
  //         this.api.getDefaultHeaders(),
  //         null,
  //         transaction,
  //         this.options
  //         ).then((t) => t.transactionId);

  // }

  getPaged(query: string, data: any): Promise<Page<TransactionFacade>> {
    data.q = query;

    let usr = this.storage.getCurrentUser();

    if (usr) {
      data.userId = usr.id;
    }

    return this.api
      .apiCallSane(
        '/transactions',
        'GET',
        this.api.getDefaultHeaders(),
        data,
        null,
        this.options,
      )
      .then(
        (response: Partial<Page<TransactionFacade>>) =>
          new Page<TransactionFacade>(response),
      );
  }

  getTransaction(transactionId: string): Promise<TransactionFacade> {
    return this.get({ transactionId: transactionId });
  }

  getRecentMerchantTransactions(
    merchantId: string,
    pageNum: number,
    pageSize: number,
  ): Promise<Page<TransactionFacade>> {
    return this.getPaged('', {
      merchantId: merchantId,
      pageNum: pageNum,
      pageSize: pageSize,
    });
  }

  getMerchantTransactionsForRefund(
    merchantId: string,
    pageNum: number,
    pageSize: number,
  ): Promise<Page<TransactionFacade>> {
    return this.getPaged('', {
      merchantId: merchantId,
      forRefund: true,
      pageNum: pageNum,
      pageSize: pageSize,
    });
  }

  getCustomerTransactions(
    customerId: string,
    transactionTypes: string[],
  ): Promise<Page<TransactionFacade>> {
    return this.getPaged('', {
      customerId: customerId,
    });
  }

  public cancelRecurringPayment(
    orderId: string,
    transactionType: string,
  ): Promise<void> {
    return this.api.apiCallSane(
      '/transaction/cancel-recurring-payment',
      'POST',
      this.api.getDefaultHeaders(),
      null,
      { orderId: orderId, transactionType: transactionType },
      this.options,
    );
  }

  private get(data: any): Promise<TransactionFacade> {
    return this.api.apiCallSane(
      '/transaction',
      'GET',
      this.api.getDefaultHeaders(),
      data,
      null,
      this.options,
    );
  }

    
    private getTimezone(timeZone?: string): string {
    if (timeZone) {
        try {
          Intl.DateTimeFormat(undefined, { timeZone }); // will fail if invalid timezone
          return timeZone;
        } catch (error) {
          console.error(`Invalid timezone passed to getTimezone: ${timeZone}`);
        }
      }
      return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    }
  
    private graphUrl(merchantId?: string): string {
      return merchantId ? `/merchants/graphs/transactions/${merchantId}` : '/merchants/graphs/transactions';
    }
  
    private getGraphs(
      params: Record<string, string | number | boolean>,
      merchant?: Merchant
    ): Promise<TransactionSummary[]> {
      return this.api.apiCallSane(
        this.graphUrl(merchant?.id),
        'GET',
        this.api.getDefaultHeaders(),
        { tz: this.getTimezone(), ...params },
        null,
        this.options,
      );
    }
  
    /** One row per day of the given month. Omit merchantId for all merchants. */
    getDailyGraph(
      year: number,
      month: number,
      merchant?: Merchant,
      maxList = 10,
      sandbox = false,
    ): Promise<TransactionSummary[]> {
      return this.getGraphs({ period: 'day', year, month, maxList, sandbox }, merchant);
    }
  
    /** One row per day for the `days` days ending on endDate (YYYY-MM-DD), inclusive. */
    getTrailingDailyGraph(
      endDate: string,
      days: number,
      merchant?: Merchant,
      maxList = 10,
      sandbox = false,
    ): Promise<TransactionSummary[]> {
      return this.getGraphs({ period: 'trailing', endDate, days, maxList, sandbox }, merchant);
    }
  
    /** One row per ISO week, Monday to Sunday, start through end inclusive. */
    getWeeklyGraph(
      year: number,
      week: number,
      yearEnd: number,
      weekEnd: number,
      merchant?: Merchant,
      maxList = 10,
      sandbox = false,
    ): Promise<TransactionSummary[]> {
      return this.getGraphs({ period: 'week', year, week, yearEnd, weekEnd, maxList, sandbox }, merchant);
    }
  
    /** One row per month, start through end inclusive. */
    getMonthlyGraph(
      year: number,
      month: number,
      yearEnd: number,
      monthEnd: number,
      merchant?: Merchant,
      maxList = 10,
      sandbox = false,
    ): Promise<TransactionSummary[]> {
      return this.getGraphs({ period: 'month', year, month, yearEnd, monthEnd, maxList, sandbox }, merchant);
    }

}
